import { useEffect, useMemo, useState, useCallback } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { api } from "../../lib/api";

const COLORS = { open: "bg-white border-teal-600 text-teal-800", blocked: "bg-slate-100 border-slate-200 text-slate-400 line-through", booked: "bg-teal-700 border-teal-700 text-white", reserved: "bg-amber-100 border-amber-300 text-amber-800" };

export default function SlotManager() {
  const [slots, setSlots] = useState([]);
  const [form, setForm] = useState({ date: "", start_time: "10:00", end_time: "13:00" });

  const load = useCallback(() => api.get("/slots").then(r => setSlots(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const byDay = useMemo(() => slots.reduce((m, s) => ((m[s.ist_date] = m[s.ist_date] || []).push(s), m), {}), [slots]);

  const create = async () => {
    try { const { data } = await api.post("/admin/slots", form); toast.success(`${data.created} slots added`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const toggle = async (s) => {
    if (s.status === "booked" || s.status === "reserved") return toast.info(s.status === "booked" ? "This slot has a confirmed booking — cancel it from Bookings first." : "A patient is completing payment for this slot.");
    try { await api.patch(`/admin/slots/${s.id}/${s.status === "open" ? "block" : "open"}`); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="mt-6 space-y-8">
      <div className="bg-white border border-slate-200 rounded-xl p-5 flex flex-wrap gap-4 items-end" data-testid="slot-create-form">
        <div className="space-y-1"><Label>Date</Label><Input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} data-testid="slot-date-input" /></div>
        <div className="space-y-1"><Label>From (IST)</Label><Input type="time" value={form.start_time} onChange={e => setForm({ ...form, start_time: e.target.value })} data-testid="slot-start-input" /></div>
        <div className="space-y-1"><Label>To (IST)</Label><Input type="time" value={form.end_time} onChange={e => setForm({ ...form, end_time: e.target.value })} data-testid="slot-end-input" /></div>
        <Button disabled={!form.date} onClick={create} className="bg-teal-700 hover:bg-teal-800 text-white" data-testid="slot-create-btn">Add 20-min slots</Button>
      </div>
      <p className="text-sm text-slate-500">Click an open slot to block it; click a blocked slot to reopen it.</p>
      {Object.keys(byDay).sort().map(d => (
        <div key={d}>
          <div className="font-medium text-slate-900 mb-2">{new Date(d + "T12:00:00").toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "short" })}</div>
          <div className="flex flex-wrap gap-2">
            {byDay[d].map(s => (
              <button key={s.id} onClick={() => toggle(s)} title={s.status} data-testid={`admin-slot-${d}-${s.ist_time.replace(":", "")}`}
                className={`px-3 py-1.5 rounded-md border text-sm ${COLORS[s.status]}`}>{s.ist_time}</button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
